// extracted by mini-css-extract-plugin
module.exports = {"dream_post_detail":"DreamPostDetail_dream_post_detail_dK811","img":"DreamPostDetail_img_1Sqkb","message":"DreamPostDetail_message_1J0io"};